export default __webpack_public_path__ + "static/media/icon-coin-dfi.12257591.svg";